import React, { useEffect } from "react";
import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import HowWeHelp from "@/components/sections/HowWeHelp";
import HowItWorks from "@/components/sections/HowItWorks";
import WhyUs from "@/components/sections/WhyUs";
import HomeResources from "@/components/sections/HomeResources";
import GuideMagnet from "@/components/sections/GuideMagnet";
import FinalCta from "@/components/sections/FinalCta";
import Footer from "@/components/sections/Footer";
import Seo, { ORGANIZATION_SCHEMA, WEBSITE_SCHEMA } from "@/components/Seo";
import SpainCheckin from "@/components/SpainCheckin";
import { usePersona } from "@/contexts/PersonaContext";
import { trackEvent } from "@/lib/analytics";

const SEO = {
  title: "Moving to Spain from the USA | Destino Europe",
  description:
    "Destino Europe helps Americans plan and coordinate a move to Spain, from the first decisions to getting settled, with knowledgeable support on the ground. Schedule a free call.",
};

export default function Landing() {
  const { ready, checkinDone } = usePersona();

  useEffect(() => {
    trackEvent("landing_view", { country: "Spain" });
  }, []);

  return (
    <main data-testid="landing-page" className="min-h-screen bg-[#F5EFE7] text-[#451C25]">
      <Seo title={SEO.title} description={SEO.description} path="/" jsonLd={[ORGANIZATION_SCHEMA, WEBSITE_SCHEMA]} />
      {ready && !checkinDone && <SpainCheckin />}
      <Header />
      <Hero />
      <HowWeHelp />
      <HowItWorks />
      <WhyUs />
      <HomeResources />
      <GuideMagnet />
      <FinalCta />
      <Footer />
    </main>
  );
}
